import Avatar from "../../ui/avatar/Avatar";
import Button from "../../ui/buttons/Button";
import LoadingSpinner from "../../ui/spinner/LoadingSpinner";
import { formatReceivedAt } from "../../utils/formatReceivedAt";
import {
  buildUnassignedMailPills,
  getSenderDisplayName,
} from "./unassignedMailPills";

import styles from "./UnassignedMailList.module.css";

const EMPTY_MESSAGES = {
  pending: "No hay correos pendientes de asignar.",
  ignored: "No hay correos ignorados.",
  assigned: "Todavía no vinculaste ningún correo desde acá.",
};

const UnassignedMailList = ({
  mails = [],
  status = "pending",
  search = "",
  selectedId = null,
  loading = false,
  loadingMore = false,
  hasMore = false,
  error = null,
  onSelect,
  onRetry,
  onLoadMore,
}) => {
  if (loading) {
    return (
      <div className={styles.state} role="status">
        <LoadingSpinner size={24} thickness={3} />
        <span>Cargando correos...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.state} role="alert">
        <span>{error}</span>
        <Button variant="primary" tone="blue" height={36} onClick={onRetry}>
          Reintentar
        </Button>
      </div>
    );
  }

  if (mails.length === 0) {
    return (
      <div className={styles.state}>
        {search.trim()
          ? `Sin resultados para “${search.trim()}”.`
          : EMPTY_MESSAGES[status] || EMPTY_MESSAGES.pending}
      </div>
    );
  }

  return (
    <div className={styles.list} role="listbox" aria-label="Correos sin asignar">
      {mails.map((mail) => {
        const senderName = getSenderDisplayName(mail);
        const isSelected = mail.id === selectedId;

        return (
          <button
            key={mail.id}
            type="button"
            role="option"
            aria-selected={isSelected}
            className={isSelected ? `${styles.row} ${styles.rowActive}` : styles.row}
            onClick={() => onSelect?.(mail)}
          >
            <Avatar name={senderName} size={36} />
            <span className={styles.rowBody}>
              <span className={styles.rowHeader}>
                <span className={styles.sender}>{senderName}</span>
                <span className={styles.date}>
                  {formatReceivedAt(mail.received_at)}
                </span>
              </span>
              <span className={styles.subject}>
                {mail.subject || "(Sin asunto)"}
              </span>
              <span className={styles.snippet}>{mail.snippet}</span>
              <span className={styles.pills}>
                {buildUnassignedMailPills(mail).map((pill) => (
                  <span
                    key={pill.label}
                    className={`${styles.pill} ${styles[`pill_${pill.tone}`]}`}
                  >
                    {pill.label}
                  </span>
                ))}
              </span>
            </span>
          </button>
        );
      })}

      {loadingMore && (
        <div className={styles.loadingMore} role="status">
          <LoadingSpinner size={14} thickness={2} />
          <span>Cargando más correos...</span>
        </div>
      )}

      {hasMore && !loadingMore && (
        <div className={styles.loadMore}>
          <Button variant="secondary" tone="blue" height={32} onClick={onLoadMore}>
            Cargar más correos
          </Button>
        </div>
      )}
    </div>
  );
};

export default UnassignedMailList;
